import { FC, useCallback } from 'react';
import { apiDonationPagesExport } from 'src/api/organization';
import { apiDonationPagesExportStatus } from 'src/api/taskStatus';
import { ExportButton } from 'src/components/common/ExportButton';

type Props = {
  id: string;
};

export const DonationPageListExportButton: FC<Props> = ({ id }) => {
  const exportFn = useCallback(() => apiDonationPagesExport(id), [id]);
  const checkStatusFn = useCallback(() => apiDonationPagesExportStatus(id), [id]);

  return <ExportButton exportFn={exportFn} checkStatusFn={checkStatusFn} className="btn-flat export" />;
};
